import { Injectable, inject, signal, DestroyRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { NotificationDto } from '../../shared/models/messagerie.interface';
import { API_ENDPOINTS } from '../constants/api.constants';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly http = inject(HttpClient);
  private readonly destroyRef = inject(DestroyRef);
  
  private pollingSubscription: Subscription | null = null;
  readonly unreadCount = signal<number>(0);
  readonly unreadNotifications = signal<NotificationDto[]>([]);

  getNonLues(): Observable<NotificationDto[]> {
    return this.http.get<NotificationDto[]>(API_ENDPOINTS.NOTIFICATIONS.NON_LUES).pipe(
      tap(notifs => {
        this.unreadNotifications.set(notifs);
        this.unreadCount.set(notifs.length);
      })
    );
  }

  marquerLue(id: string): Observable<NotificationDto> {
    return this.http.post<NotificationDto>(API_ENDPOINTS.NOTIFICATIONS.MARQUER_LUE(id), {}).pipe(
      tap(() => this.getNonLues().subscribe())
    );
  }

  startPolling(intervalMs = 30000): void {
    if (this.pollingSubscription) {
      return;
    }

    this.pollingSubscription = timer(0, intervalMs).pipe(
      switchMap(() => this.getNonLues())
    ).subscribe();

    this.destroyRef.onDestroy(() => this.stopPolling());
  }

  stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = null;
    }
  }
}
